import Socials from '../../../blocks/socials/socials';
import ScrollMagic from 'scrollmagic';
$(() => {
    const controller = new ScrollMagic.Controller();
    let h = $('.l-page__blog-article').height() - $('.js-socials').height();
    const scene = new ScrollMagic.Scene({
        triggerElement: '.l-page__blog-article',
        triggerHook: 0,
        duration: h
    })
    .setPin('.js-socials')
    .addTo(controller);

    if (window.matchMedia('(min-width: 1199px)').matches) {
        scene.setPin('.js-socials', {pushFollowers: false});
    }

    window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 1199px)').matches) {
          scene.setPin('.js-socials', {pushFollowers: false});
        } else {
          scene.removePin('.js-socials', true);
        }
    });
});



// WEBPACK FOOTER //
// ./app/scripts/pages/blog/article.js